import { Navigate, Outlet } from "react-router-dom";

const Authentication = () => {
  let user = JSON.parse(localStorage.getItem("user"));
  return user ? <Outlet /> : <Navigate to="/" />;
};

export default Authentication;
